import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Subscription, timer } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VersionCheckService {
    newVersionAvailable: boolean = false;
    versionCheckInterval: Subscription;
    currentVersion: string;
    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar,
        private progress: FuseProgressBarService
    ) {}

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    checkVersion(url: string) {
        // Timestamp these requests to invalidate caches
        this.http.get(`${url}?t=${new Date().getTime()}`).subscribe(
            (response: any) => {
                const { version } = response;
                if (!this.currentVersion) {
                    this.currentVersion = version;
                }
                this.newVersionAvailable = this.hasHashChanged(version);

                console.log('Check New Version:', version, ' Old Version:', this.newVersionAvailable);

                // Stop checking for a new version if a new version is already available
                if (this.newVersionAvailable) {
                    this.stopVersionChecking();
                    console.log('NewVersion:true');

                    const snackBarRef = this.snackBar.open(
                        'Good news, there\'s a new version of CAMPUS available! Click "Update" to upgrade.',
                        'Update',
                        {
                            duration: 14400000,
                            panelClass: ['my-content', 'mat-simple-snackbar-action-info'],
                            verticalPosition: 'top',
                        }
                    );

                    snackBarRef.onAction().subscribe(() => {
                        console.log('NewVersion reload !');
                        if (navigator.onLine) {
                            window.location.reload();
                        }
                    });
                }
            },
            err => {
                console.error(err, 'Error checking version');
            },
            () => {
                this.progress.hide();
            }
        );
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    hasHashChanged(newVersion: string) {
        if (newVersion == this.currentVersion) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * Starts the version check interval for the specified frequency.
     * @param url - The URL to check for the application version.
     * @param {number} frequency - The frequency in milliseconds (defaults to 30 minutes).
     */
    public startVersionChecking(url: string, frequency = 1800000) {
        this.versionCheckInterval = timer(0, frequency).subscribe(() => {
            this.checkVersion(url);
        });
    }

    /** Stops the version check interval. */
    public stopVersionChecking() {
        if (this.versionCheckInterval) {
            this.versionCheckInterval.unsubscribe();
        }
    }
}
